import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { FEEDBACK_ACTIONS } from '../actions/FeedbackActions';
import { FeedbackPropTypes } from '../FeedbackPropTypes';

const initialState = () => ({
    currentRecord: { ...FeedbackPropTypes },

    search: {
        data: [],
        groupCounts: { allUsers: 0, inHouseUsers: 0, orangeUsers: 0 },
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    uploadReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {

        case FEEDBACK_ACTIONS.FEEDBACK_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case FEEDBACK_ACTIONS.FEEDBACK_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case FEEDBACK_ACTIONS.FEEDBACK_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }


        case FEEDBACK_ACTIONS.FEEDBACK_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case FEEDBACK_ACTIONS.FEEDBACK_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case FEEDBACK_ACTIONS.FEEDBACK_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }


        case FEEDBACK_ACTIONS.FEEDBACK_UPLOAD: {
            return {
                ...state,
                uploadReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case FEEDBACK_ACTIONS.FEEDBACK_UPLOAD_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                uploadReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case FEEDBACK_ACTIONS.FEEDBACK_UPLOAD_ERROR: {
            return {
                ...state,
                uploadReqStatus: REQUEST_STATUS.ERROR,
            };
        }


        case FEEDBACK_ACTIONS.FEEDBACK_RESET: {
            return {
                ...state,
                currentRecord: {
                    _id: undefined,
                    firstName: '',
                    lastName: '',
                    email: '',
                    employeeID: '',
                    phone: '',
                    isAdmin: false,
                    status: true,
                    username: '',
                    password: 'acadecraft@123',
                    otherInformation: {
                        designationId: '',
                        departmentId: '',
                        locationId: '',
                        reportingManagerId: null,
                    },
                },
            };
        }

        default:
            return state;
    }
};
